import * as React from "react";
import Icon from "common/icons";
import HlsVideo from "common/components/hlsVideo";
import Equalizer from "common/components/equalizer";
import ImageHolder from "common/components/imageHolder";
import MediaLazyTransitionWrapper from "common/components/mediaWrapper";

// styles
const styles = require("./multiMedia.scss");

interface IMultiMediaProps {
  data: Vingle.CardContent.MediaData;
  className?: string;
  width: number;
  height: number;
  autoPlay?: boolean;
  hideBadge?: boolean;
}

const getMediaWidthAndHeight = ({
  mediaRatio,
  containerRatio,
  width,
  height,
}: {
  mediaRatio: number;
  containerRatio: number;
  width: number;
  height: number;
}) => {
  return {
    mediaWidth:
      mediaRatio > containerRatio
        ? Math.floor(width)
        : mediaRatio === containerRatio
        ? Math.floor(width)
        : Math.floor(height / mediaRatio),
    mediaHeight:
      mediaRatio > containerRatio
        ? Math.floor(width * mediaRatio)
        : Math.floor(height),
  };
};

class MultiMedia extends React.PureComponent<IMultiMediaProps> {
  public render() {
    const { data, className, width, height, autoPlay, hideBadge } = this.props;

    if (data.type === "embedded-video") return null;
    if (data.type === "link-preview") return null;

    const mediaRatio = data.height / data.width;
    const containerRatio = height / width;
    const { mediaWidth, mediaHeight } = getMediaWidthAndHeight({
      width,
      height,
      containerRatio,
      mediaRatio,
    });

    const style = {
      width: `${mediaWidth}px`,
      height: `${mediaHeight}px`,
    };

    switch (data.type) {
      case "image": {
        return (
          <div style={style} className={styles.videoWrapper}>
            <ImageHolder
              src={data.src}
              className={className}
              width={mediaWidth}
              height={mediaHeight}
              previewColor={data.previewColor}
              blurHash={data.blurHash}
              srcSet={data.srcset}
              wrapperClassName={styles.imageHolder}
            />
          </div>
        );
      }
      case "video": {
        let videoElement: React.ReactNode;
        let badgeElement;

        if (data.originalType === "image/gif") {
          badgeElement = (
            <div className={styles.badge}>
              <span className={styles.badgeText}>GIF</span>
            </div>
          );

          const mp4Source = data.sources.find(
            source => source.type === "video/mp4",
          );
          if (!mp4Source) {
            videoElement = (
              <ImageHolder
                fit="cover"
                style={style}
                src={data.sources[0].src}
                previewColor={data.previewColor}
                blurHash={data.blurHash}
                wrapperClassName={styles.imageHolder}
                width={mediaWidth}
                height={mediaHeight}
              />
            );
          } else {
            videoElement = (
              <MediaLazyTransitionWrapper
                src={mp4Source.src}
                type="video"
                width={mediaWidth}
                height={mediaHeight}
                previewColor={data.previewColor}
                blurHash={data.blurHash}
              >
                <video
                  style={style}
                  className={className}
                  src={mp4Source.src}
                  poster={data.poster}
                  autoPlay={autoPlay}
                  loop={true}
                  muted={true}
                />
              </MediaLazyTransitionWrapper>
            );
          }
        } else {
          if (autoPlay) {
            badgeElement = (
              <div className={styles.badge}>
                <Equalizer active={true} />
              </div>
            );

            videoElement = (
              <HlsVideo
                type={data.type}
                style={style}
                width={mediaWidth}
                height={mediaHeight}
                className={className}
                sources={data.sources}
                poster={data.poster}
                previewColor={data.previewColor}
                blurHash={data.blurHash}
                autoPlay={autoPlay}
                fluid={true}
                muted={true}
                loop={true}
              />
            );
          } else {
            badgeElement = (
              <div className={styles.playButton}>
                <Icon icon="COMPACT_CARD_PLAY_BUTTON" />
              </div>
            );

            videoElement = (
              <ImageHolder
                fit="cover"
                style={style}
                src={data.poster}
                width={mediaWidth}
                height={mediaHeight}
                blurHash={data.blurHash}
                previewColor={data.previewColor}
                wrapperClassName={styles.imageHolder}
              />
            );
          }
        }

        return (
          <div className={styles.videoContainer}>
            <div style={style} className={styles.videoWrapper}>
              {videoElement}
            </div>
            {badgeElement && !hideBadge ? badgeElement : null}
          </div>
        );
      }
      default:
        return null;
    }
  }
}
export default MultiMedia;
